import styles from './index.module.css';
import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useRef } from 'react';

gsap.registerPlugin(ScrollTrigger);

const ServicesSection = () => {

    const containerRef = useRef(null);

      useGSAP(() => {
    // Select all the cards within the container
    const cards = containerRef.current.querySelectorAll(`.${styles.gridCard}`);

    gsap.from(cards, {
      y: 50, // Start 50px below their final position
      opacity: 0, // Start with opacity 0 (invisible)
      stagger: 0.1, // Animate each card with a 0.2-second delay
      ease: "power2.out",
      scrollTrigger: {
        trigger: containerRef.current,
        start: "top 80%", // Trigger when the top of the container is 80% down from the top of the viewport
        end: "bottom center",
        scrub: true, 
      }
    });
  }, { scope: containerRef });

    return (
        <div ref={containerRef} className={`main-container, ${styles.servicesSec}`}>
            <div className={`container-content`}>
                <div className={styles.statContainer}>
                    <div className={styles.statsTitle}>Services Tailored for You</div>
                    <div className={styles.statsCards}>
                        <div className={`${styles.gridCard} ${styles.gridCardOne}`}>
                            <div className={styles.cardColOne}>
                                <div className={styles.cardTitle}>
                                    Website Development
                                </div>
                                <p className={styles.cardSubTitle}>Engaging Websites That Drive Results</p>
                                <p className={styles.cardText}>We design and develop modern, responsive websites that not only look stunning but also perform seamlessly across all devices. From business portfolios to e-commerce platforms, we create websites that help your brand stand out and deliver measurable results.</p>
                            </div>
                        </div>
                          <div className={`${styles.gridCard} ${styles.gridCardTwo}`}>
                            <div className={styles.cardColOne}>
                                <div className={styles.cardTitle}>
                                   Web Systems & Applications
                                </div>
                                <p className={styles.cardSubTitle}>Scalable Web Systems for Smarter Business</p>
                                <p className={styles.cardText}>Streamline your operations with custom-built web applications tailored to your business needs. Whether it’s a management system, booking platform, or enterprise solution, we engineer secure, scalable, and user-friendly systems that simplify workflows and boost productivity.</p>
                            </div>
                        </div>
                          <div className={`${styles.gridCard} ${styles.gridCardOne}`}>
                            <div className={styles.cardColOne}>
                                <div className={styles.cardTitle}>
                                    Mobile App Development
                                </div>
                                <p className={styles.cardSubTitle}>Powerful Mobile Apps That Connect People</p>
                                <p className={styles.cardText}>Reach your audience on the go with intuitive, high-performing mobile applications. We craft Android and iOS apps with sleek design and robust functionality, ensuring smooth user experiences that keep your customers engaged.</p>
                            </div>
                        </div>
                          <div className={`${styles.gridCard} ${styles.gridCardTwo}`}>
                            <div className={styles.cardColOne}>
                                <div className={styles.cardTitle}>
                                    Custom Software Solutions
                                </div>
                                <p className={styles.cardSubTitle}>Technology Built Around Your Vision</p>
                                <p className={styles.cardText}>Every business is unique — your software should be too. We develop tailored solutions that solve real problems, automate processes, and unlock new opportunities, helping your business stay ahead in a fast-changing digital world.</p>
                           </div>
                        </div>
                          <div className={`${styles.gridCard} ${styles.gridCardTwo}`}>
                            <div className={styles.cardColOne}>
                                <div className={styles.cardTitle}>
                                    UI/UX Design
                                </div>
                                <p className={styles.cardSubTitle}>Design That Blends Beauty and Functionality</p>
                                <p className={styles.cardText}>Great design goes beyond aesthetics — it’s about creating experiences people love. Our UI/UX design services ensure your digital products are visually appealing, intuitive, and built around your users’ needs.</p>
                           </div>
                        </div>
                          <div className={`${styles.gridCard} ${styles.gridCardTwo}`}>
                            <div className={styles.cardColOne}>
                                <div className={styles.cardTitle}>
                                    IT Consulting & Support
                                </div>
                                <p className={styles.cardSubTitle}>Your Digital Growth Partner</p>
                                <p className={styles.cardText}>Unsure where to start? We provide expert guidance to help you choose the right technologies, optimize performance, and future-proof your digital journey with ongoing support.</p>
                           </div>
                        </div>
                          <div className={`${styles.gridCard} ${styles.gridCardTwo}`}>
                            <div className={styles.cardColOne}>
                                <div className={styles.cardTitle}>
                                    AI-Powered Solutions
                                </div>
                                <p className={styles.cardSubTitle}>Smarter Businesses with Artificial Intelligence</p>
                                <p className={styles.cardText}>Harness the power of AI to transform how you work. From chatbots and predictive analytics to intelligent automation, we build AI-driven solutions that save time, reduce costs, and unlock new opportunities for growth.</p>
                           </div>
                        </div>
                          <div className={`${styles.gridCard} ${styles.gridCardTwo}`}>
                            <div className={styles.cardColOne}>
                                <div className={styles.cardTitle}>
                                   ML & Data Analytics
                                </div>
                                <p className={styles.cardSubTitle}>Turn Data Into Actionable Insights</p>
                                <p className={styles.cardText}>Data is powerful only when it tells a story. Our ML and analytics solutions help you predict trends, understand customer behavior, and make informed decisions that move your business forward.</p>
                           </div>
                        </div>
                          <div className={`${styles.gridCard} ${styles.gridCardTwo}`}>
                            <div className={styles.cardColOne}>
                                <div className={styles.cardTitle}>
                                   NLP Solutions
                                </div>
                                <p className={styles.cardSubTitle}>Understand and Respond to Human Language</p>
                                <p className={styles.cardText}>We design NLP solutions that analyze text, detect emotions, and power intelligent systems — helping you better understand and connect with your customers.</p>
                           </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ServicesSection;